// extracted by mini-css-extract-plugin
export default {"grayBorderedBox":"grayBorderedBox-5c86"};